import styled from 'styled-components';

export const Title = styled.h2`
    text-transform: capitalize;
`;
